import { useState, useEffect, useCallback } from 'react';

export const useResource = ({ fetchFn }) => {
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const run = useCallback(async () => {
		setLoading(true);
		setError(null);

		try {
			const result = await fetchFn();
			setData(result);
		} catch (err) {
			setError(err?.message ?? null);
			setData(null);
		} finally {
			setLoading(false);
		}
	}, [fetchFn]);

	useEffect(() => {
		run();
	}, [run]);

	return { data, loading, error, refetch: run };
};
